// translations.js
const translations = {
  en: {
        "success": "Success",
        'register': 'Register',
        'sign up': 'Sign up',
        'share': "Share",
        'feedback': 'Feedback',
        "search sign": "Search sign",
        "signs": "Signs",
        "not found": "Not found",
        'login': 'Login',
        'submit': "Submit",
        'forgot password': 'Forgot password',
        'cancel': 'cancel',
        'invalid password': 'Invalid password',
        'minimum length of password is 8 characters':
            'Minimum length of password is 8 characters',
        'no internet connection': 'No internet connection',
        'login required': 'Login required',
        "remove": "Remove",
        'dictionary': 'Dictionary',
        'dzongkha': 'Dzongkha',
        'about': 'About',
        'lesson': 'Lesson',
        'quiz': 'Quiz',
        'favourite': 'Favourite',

        'setting': 'Setting',
        'stories': 'Stories',
        'discourse': 'Discourse',
        'tradition':'Tradition',
        'places':'Places',
        'story':'Story',


        'baby': 'Baby',
        'family': 'Family',
        'language': 'Language',
        'mother': 'Mother',
        'father': 'Father',
        "alphabet": "Alphabet",
        "a": "A",
        "b": "B",
        "c": "C",
        "d": "D",
        "e": "E",
        "f": "F",
        "h": "H",
        "i": "I",
        "j": "J",
        "k": "K",
        "l": "L",
        "m": "M",
        "n": "N",
        "o": "O",
        "p": "P",
        "q": "Q",
        "r": "R",
        "s": "S",
        "t": "T",
        "u": "U",
        "v": "V",
        "w": "W",
        "x": "X",
        "y": "Y",
        "z": "Z",
        "animals": "Animals",
        "animal": "Animal",
        "bear": "Bear",
        "bird": "Bird",
        "boar": "Boar",
        "buffalo": "Buffalo",
        "calf": "Calf",
        "cat": "Cat",
        "cheetah": "Cheetah",
        "cow": "Cow",
        "deer": "Deer",
        "dog": "Dog",
        "donkey": "Donkey",
        "elephant": "Elephant",
        "fox": "Fox",
        "frog": "Frog",
        "giraffe": "Giraffe",
        "goat": "Goat",
        "hen": "Hen",
        "horse": "Horse",
        "leopard": "Leopard",
        "lion": "Lion",
        "monkey": "Monkey",
        "panther": "Panther",
        "rabbit": "Rabbit",
        "rat": "Rat",
        "rooster": "Rooster",
        "shark": "Shark",
        "sheep": "Sheep",
        "snake": "Snake",
        "takin": "Takin",
        "tiger": "Tiger",
        "whale": "Whale",
        "yak": "Yak",
        "capital city": "Capital city",
        "bangkok": "Bangkok",
        "new delhi": "New Delhi",
        "classroom equipment": "Classroom equipment",
        "bag": "Bag",
        "book": "Book",
        "chair": "Chair",
        "chalk": "Chalk",
        "chart paper": "Chart paper",
        "clock": "Clock",
        "crayon": "Crayon",
        "dustbin": "Dustbin",
        "duster": "Duster",
        "eraser": "Eraser",
        "greenboard": "Greenboard",
        "notebook": "Notebook",
        "paper": "Paper",
        "pencil": "Pencil",
        "ruler": "Ruler",
        "sharpener": "Sharpener",
        "scissors": "Scissors",
        "table": "table",
        "white board": "White board",
        "colours": "Colours",
        "colour": "Colour",
        "black": "Black",
        "blue": "Blue",
        "brown": "Brown",
        "green": "Green",
        "grey": "Grey",
        "orange": "Orange",
        "pink": "Pink",
        "purple": "Purple",
        "red": "Red",
        "white": "White",
        "yellow": "Yellow",
        "clothes": "Clothes",
        "buttoned shirt": "Buttoned shirt",
        "gho": "Gho",
        "half pants": "Half pants",
        "hook bra": "Hook bra",
        "jacket": "Jacket",
        "jeans": "Jeans",
        "kera": "Kera",
        "kira": "Kira",
        "pants": "Pants",
        "rachu": "Rachu",
        "shirt": "Shirt",
        "shoes": "Shoes",
        "socks": "Socks",
        "numbers":"Numbers",
        "sentences":"Sentences",
        "sport bra": "Sport bra",
        "sweater": "Sweater",
        "tsho lham": "Tsho lham",
        "underwear": "Underwear",
        "vest": "Vest",
        "continent": "Continent",
        'asia': 'Asia',
        'america': 'America',
        'south america': "South America",
        "north america": "North America",
        'africa': 'Africa',
        "country": "Country",
        "afghanistan": "Afghanistan",
        "australia": "Australia",
        "austria": "Austria",
        "bangladesh": "Bangladesh",
        "belgium": "Belgium",
        "bhutan": "Bhutan",
        "brazil": "Brazil",
        "cambodia": "Cambodia",
        "canada": "Canada",
        "china": "China",
        "egypt": "Egypt",
        "england": "England",
        "france": "France",
        "germany": "Germany",
        "hong kong": "Hong Kong",
        "india": "India",
        "indonesia": "Indonesia",
        "iran": "Iran",
        "italy": "Italy",
        "Jamaica": "Jamaica",
        "japan": "Japan",
        "malaysia": "Malaysia",
        "mexico": "Mexico",
        "myanmar": "Myanmar",
        "nepal": "Nepal",
        "netherlands": "Netherlands",
        "north korea": "North Korea",
        "pakistan": "Pakistan",
        "panama": "Panama",
        "philippines": "Philippines",
        "russia": "Russia",
        "singapore": "Singapore",
        "south korea": "South Korea",
        "spain": "Spain",
        "sri lanka variant 1": "Sri Lanka Variant 1",
        "sri lanka variant 2": "Sri Lanka Variant 2",
        "switzerland": "Switzerland",
        "taiwan": "Taiwan",
        "thailand": "Thailand",
        "turkey": "Turkey",
        "ukraine": "Ukraine",
        "united states of america": "United States of America",
        "vietnam": "Vietnam",
        "days of week": "Days of week",
        "friday": "Friday",
        "monday": "Monday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "thursday": "Thursday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "disaster": "Disaster",
        "earthquake": "Earthquake",
        "fire": "Fire",
        "flood": "Flood",
        "landslide": "Landslide",
        "storm": "Storm",
        "dzongkhags": "Dzongkhags",
        "bumthang": "Bumthang",
        "chhukha": "Chhukha",
        "dagana": "Dagana",
        "dzongkhag": "Dzongkhag",
        "gasa": "Gasa",
        "haa": "Haa",
        "lhuentse": "Lhuentse",
        "monggar": "Monggar",
        "paro": "Paro",
        "pemagatshel": "Pemagatshel",
        "punakha": "Punakha",
        "samdrup jongkhar": "Samdrup Jongkhar",
        "samtse": "Samtse",
        "sarpang": "Sarpang",
        "thimphu": "Thimphu",
        "trashigang": "Trashigang",
        "trashiyangtse": "Trashiyangtse",
        "trongsa": "Trongsa",
        "tsirang": "Tsirang",
        "wangdue phodrang": "Wangdue Phodrang",
        "zhemgang": "Zhemgang",
        "environment": "Environment",
        "forest": "Forest",
        "grass": "Grass",
        "moon": "Moon",
        "mountain": "Mountain",
        "rainbow": "Rainbow",
        "river": "River",
        "sea": "Sea",
        "soil": "Soil",
        "star": "Star",
        "stick": "Stick",
        "stone": "Stone",
        "stream": "Stream",
        "sun": "Sun",
        "family member": "Family member",
        "food & drinks": "Food & drinks",
        "fruits": "Fruits",
        "game": "Game",
        "household items": "Household items",
        "job": "Job",
        "ministry": "Ministry",
        "money": "Money",
        "nu fifty": "Nu. 50",
        "nu five": "Nu. 5",
        "nu five hundred": "Nu. 500",
        "nu one": "Nu. 1",
        "nu one hundred": "Nu. 100",
        "nu one thousand": "Nu. 1000",
        "nu ten": "Nu. 10",
        "nu twenty": "Nu. 20",
        "months": "Months",
        "parts of tree": "Parts of tree",
        "parts of a tree": "Parts of a tree",
        "place": "Place",
        "seasons": "Seasons",
        "subjects": "Subjects",
        "time": "Time",
        "12 30": "12:30 pm",
        "3 o clock": "3 o'clock",
        "afternoon": "Afternoon",
        "evening": "Evening",
        "traditional game": "Traditional game",
        "transportation": "Transportation",
        "vegetables": "Vegetables",
        "husband": "Husband",
        "grandmother": "Grandmother",
        "grandfather": "Grandfather",
        "daughter": "Daughter",
        "cousin": "Cousin",
        "aunty": "Aunty",
        "aunt": "Aunt",
        "son": "Son",
        "uncle": "Uncle",
        "wife": "Wife",
        "biscuit": "Biscuit",
        "bread": "Bread",
        "butter": "Butter",
        "cake": "Cake",
        "cheese": "Cheese",
        "chicken": "Chicken",
        "coffee": "Coffee",
        "curd": "Curd",
        "curry": "Curry",
        "egg": "Egg",
        "food and drinks": "Food and Drinks",
        "ice cream": "Ice cream",
        "jam": "Jam",
        "juice": "Juice",
        "meat": "Meat",
        "milk": "Milk",
        "momo": "Momo",
        "noodles": "Noodles",
        "oil": "Oil",
        "pickle": "Pickle",
        "pizza": "Pizza",
        "pork": "Pork",
        "rice": "Rice",
        "roti": "Roti",
        "salt": "Salt",
        "soup": "Soup",
        "sugar": "Sugar",
        "suja": "Suja",
        "tea": "Tea",
        "tetra pack juice with straw": "Tetra pack Juice with straw",
        "water": "Water",
        "water filter": "Water filter",
        "wine": "Wine",
        "zaw": "Zaw",
        "apple": "Apple",
        "apricot": "Apricot",
        "banana": "Banana",
        "cardamom": "Cardamom",
        "Cheery": "Cheery",
        "coconut": "Coconut",
        "cucumber": "Cucumber",
        "grapes": "Grapes",
        "jackfruit": "Jackfruit",
        "litchi": "Litchi",
        "mango": "Mango",
        "orange(fruit)": "Orange",
        "papaya": "Papaya",
        "peach": "Peach",
        "peanut": "peanut",
        "pear": "Pear",
        "persimmon": "Persimmon",
        "pineapple": "pineapple",
        "plum": "Plum",
        "pomegranate": "Pomegranate",
        "strawberry": "Strawberry",
        "sugarcane": "Sugarcane",
        "walnut": "Walnut",
        "watermelon": "Watermelon",
        "badminton": "Badminton",
        "basketball": "Basketball",
        "carrom": "Carrom",
        "football": "Football",
        "lawn tennis": "Lawn tennis",
        "skipping rope": "skipping rope",
        "snooker": "Snooker",
        "volleyball": "Volleyball",
        "bucket": "Bucket",
        "cup": "Cup",
        "curry cooker": "Curry Cooker",
        "fork": "Fork",
        "gas stove": "Gas stove",
        "glass": "glass",
        "knife": "Knife",
        "mug": "Mug",
        "plate": "Plate",
        "pot": "Pot",
        "rice cooker": "Rice cooker",
        "spoon": "Spoon",
        "television": "Television",
        "washing machine": "Washing machine",
        "water boiler": "Water boiler",
        "carpenter": "Carpenter",
        "doctor": "Doctor",
        "electrician": "Electrician",
        "engineer": "Engineer",
        "guard": "Guard",
        "judge": "Judge",
        "nurse": "Nurse",
        "pilot": "Pilot",
        "police": "Police",
        "shopkeeper": "Shopkeeper",
        "teacher": "Teacher",
        "ministry of agriculture and forests":
            "Ministry of Agriculture and Forests",
        "ministry of economic affairs": "Ministry of Economic Affairs",
        "ministry of education": "Ministry of Education",
        "ministry of finance": "Ministry of Finance",
        "ministry of foreign affairs": "Ministry of Foreign Affairs",
        "ministry of health": "Ministry of Health",
        "ministry of home and cultural affairs":
            "Ministry of Home and Cultural Affairs",
        "ministry of information and communications":
            "Ministry of Information and Communications",
        "ministry of labour and human resources":
            "Ministry of Labour and Human Resources",
        "ministry of works and human settlement":
            "Ministry of Works and Human Settlement",
        "nu 1": "Nu 1",
        "nu 5": "Nu 5",
        "nu 10": "Nu 10",
        "nu 20": "Nu 20",
        "nu 50": "Nu 50",
        "nu 100": "Nu 100",
        "nu 500": "Nu 500",
        "nu 1000": "Nu 1000",
        "april": "April",
        "august": "August",
        "december": "December",
        "february": "February",
        "january": "January",
        "july": "July",
        "june": "June",
        "march": "March",
        "may": "May",
        "november": "November",
        "october": "October",
        "september": "September",
        "branch": "Branch",
        "bud": "Bud",
        "flower": "Flower",
        "fruit": "Fruit",
        "leaf": "Leaf",
        "root": "Root",
        "tree": "Tree",
        "trunk": "Trunk",
        "children park": "Children Park",
        "chorten stupa": "Chorten stupa",
        "city": "City",
        "dzong": "Dzong",
        "hospital": "Hospital",
        "hostel": "Hostel",
        "hotel": "Hotel",
        "house": "House",
        "market": "Market",
        "office": "Office",
        "salon": "Salon",
        "school": "School",
        "shop": "Shop",
        "temple": "Temple",
        "town": "Town",
        "autumn": "Autumn",
        "spring": "Spring",
        "summer": "Summer",
        "winter": "Winter",
        "agriculture": "Agriculture",
        "arts": "Arts",
        "biology": "Biology",
        "carpentry": "Carpentry",
        "chemistry": "Chemistry",
        "english": "English",
        "geography": "Geography",
        "history": "History",
        "mathematics": "Mathematics",
        "painting": "Painting",
        "physical education": "Physical education",
        "science": "Science",
        "sign language": "Sign Language",
        "social studies": "Social studies",
        "subject": "Subject",
        "tailoring": "Tailoring",
        "vocational": "Vocational",
        "weaving": "Weaving",
        "wood carving": "Wood carving",
        "12:30": "12:30",
        "future": "Future",
        "hour": "Hour",
        "last year": "Last year",
        "minute": "Minute",
        "morning": "Morning",
        "next year": "Next year",
        "next": "Next",
        "previous": "Previous",
        "night": "Night",
        "second": "Second",
        "this year": "This year",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "week": "Week",
        "year": "Year",
        "yesterday": "Yesterday",
        "archery": "Archery",
        "dego": "Dego",
        "khuru": "Khuru",
        "aeroplane": "Aeroplane",
        "ambulance": "Ambulance",
        "bicycle": "Bicycle",
        "boat": "Boat",
        "bus": "Bus",
        "car": "Car",
        "helicopter": "Helicopter",
        "hilux": "Hilux",
        "motorbike": "Motorbike",
        "scooter": "Scooter",
        "ship": "Ship",
        "taxi": "Taxi",
        "tipper": "Tipper",
        "train": "Train",
        "truck": "Truck",
        "van": "Van",
        "beans": "Beans",
        "bitter gourd": "Bitter gourd",
        "brinjal": "Brinjal",
        "broccoli": "Broccoli",
        "cabbage": "Cabbage",
        "caigua": "Ciagua",
        'caigue': "Ciague",
        "carrot": "Carrot",
        "cauliflower": "Cauliflower",
        "chilli": "Chilli",
        "coriander": "Coriander",
        "garlic": "Garlic",
        "ginger": "Ginger",
        "ladyfinger": "Ladyfinger",
        "mushroom": "Mushroom",
        "onion": "Onion",
        "peas": "Peas",
        "potato": "Potato",
        "pumpkin": "Pumpkin",
        "radish": "Radish",
        "spinach": "Spinach",
        "squash": "Squash",
        "tomato": "Tomato",
        "turnip": "Turnip",
        'settings': 'Settings',
        'ai': "AI",
        'result': 'Result',
        'home': 'Home',
        'signsCategory': 'Signs Category',

  },
  dz: {
        "success": "",
        'Register': 'ཐོ་བཀོད་མཛད་གནང་།',
        "Remove": "བཏོན་གཏང་།",
        'Sign up': 'ཐོ་བཀོད་མཛད་གནང་།',
        'Feedback': 'བསམ་ལན།', 
        "Search sign": "འཚོལ།",
        "Search signs ...": "འཚོལ།",
        "Search discourse...": "འཚོལ།",
        "Searching...":"འཚོལ་ཞིབ་འབད་དོ།",
        "Type to search": "འཚོལ་ཞིབ་འབད་ནི་ལུ་ཡིག་དཔར་རྐྱབས།",
        "share": "Share",
        "not found": "མིན་འདུག།",
        "No results found": "མིན་འདུག།",
        "result": "གྲུབ་འབྲས།",
        'login': 'འགྲུལ་སྐྱོད་གནང་།', 'Login': 'འགྲུལ་སྐྱོད་གནང་།',
        "submit": "བཙུགས་གནང་།",
        'forgot password': 'གསང་ཡིག་ཐུགས་ལུ་མ་དྲན།',
        'cancel': 'ཆ་མེད་མཛད།',
        'invalid password': 'གསང་ཡིག་འཛོལ་ནུག།',
        'minimum length of password is 8 characters':
            'གསང་ཡིག་ཐུང་ཤོས་ར་ཡིག་འབྲུ་ ༨ བཙུགས་གནང་།',
        'no internet connection': 'གློག་རིག་ཡོངས་འབྲེལ་མཐུད་སྦྲེལ་མིན་འདུག།',
        'login required': 'ནང་འཛུལ་འབད་དགོ།',
        'Dictionary': 'ཚིག་མཛོད།',
        'Dzongkha': 'རྫོང་ཁ།',
        'About': 'སྐོར་ལས།',
        'Lesson': 'སློབ་ཚན།',
        'Quiz': 'རིག་བསྡུར།', 
        'Favourite': 'དགའ་ཤོས།',
        'Setting': 'བཟོ་བཀོད།',
        'Discourse': 'གསུང་བཤད།',
        'discourse': 'གསུང་བཤད།',
        'Explore our Discourse': 'གསུང་བཤད།',
        'Explore our Quiz':'རིག་བསྡུར།',
        'Home': 'གདོང་ཤོག།',
 
        'Stories': 'སྲུང།',
        'Sentences': 'དརྗོད་ཚིག།',
        'Phrases': 'ཚོགས༌ཚིག།',
        'Phrase': 'ཚོགས༌ཚིག།',
        'Sentence': 'དརྗོད་ཚིག།',

        'Tradition': 'སྔར་སྲོལ།',
        'Places': 'ས་གནས།',
        'Story': 'སྲུང།',
        'Numbers': 'ཨང་གྲངས།',
        'Baby': 'ཨ་ལུ།',
        'Family': 'བཟའ་ཚང༌།',
        'Language': 'ཁ་སྐད།',
        'Mother': 'ཨའི།',
        'Father': 'ཨ་པ།',
        "Alphabet": "གསལ་བྱེད།",
        "a": "A",
        "b": "B",
        "c": "C",
        "d": "D",
        "e": "E",
        "f": "F",
        "h": "H",
        "i": "I",
        "j": "J",
        "k": "K",
        "l": "L",
        "m": "M",
        "n": "N",
        "o": "O",
        "p": "P",
        "q": "Q",
        "r": "R",
        "s": "S",
        "t": "T",
        "u": "U",
        "v": "V",
        "w": "W",
        "x": "X",
        "y": "Y",
        "z": "Z",
        "Animals": "སེམས་ཅན།",
        "Animal": "སེམས་ཅན།",
        "Bear": "དོམ།",
        "Bird": "བྱ།",
        "Boar": "རི་ཕག།",
        "Buffalo": "མ་ཧེ།",
        "Calf": "བོའུ་ཅུང༌།",
        "Cat": "བྱི་ལི།",
        "Cheetah": "གཟིག་གི་རིགས་ཅིག།",
        "Cow": "བ།",
        "Deer": "ཀ་ཤ།",
        "Dog": "རོ་ཁྱི།",
        "Donkey": "བོང་ཀུ།",
        "Elephant": "གླངམོ་ཆེ།",
        "Fox": "འ་དོམ།",
        "Frog": "སྦལཔ།",
        "Giraffe": "སྐེ་རིང་རྟ།",
        "Goat": "ར།",
        "Hen": "བྱམོ།",
        "Horse": "རྟ།",
        "Leopard": "གཟིག།",
        "Lion": "སེང་གེ།",
        "Monkey": "སྤྱ།",
        "Panther": "གཟིག་ནག།",
        "Rabbit": "རི་བོང༌།",
        "Rat": "བྱི་ཙི།",
        "Rooster": "བྱ་ཕོ།",
        "Shark": "ཤཱག།",
        "Sheep": "ལུག།",
        "Snake": "སྦུལ།",
        // "takin": "",
        "Tiger": "སྟག།",
        "Whale": "ཉ་ཧོབ།",
        "Yak": "གཡག།",
        "Capital city": "རྒྱལ་ས་ལྟེ་བ།",
        "bangkok": "Bangkok",
        "new delhi": "New Delhi",
        "Classroom equipment": "སློབ་ཁང་གི་ཅ་ཆས།",
        "Bag": "ཕད་ཅུང༌།",
        "Book": "དཔེ་དེབ།",
        "Chair": "རྐང་ཁྲི།",
        "Chalk": "ས་སྨྱུག།",
        "chart paper": "Chart paper",
        "Clock": "ཆུ་ཚོད་འཁོར་ལོ།",
        "Crayon": "ཚོན་སྨྱུག།",
        "Dustbin": "ཕྱགས་སྙིགས་ཧོད།",
        "Duster": "འཕྱག་རས།",
        "Eraser": "Eraser",
        "greenboard": "Greenboard",
        "Notebook": "འབྲི་དེབ།",
        "Paper": "ཤོག་ཀུ།",
        "Pencil": "པི་སི།",
        "Puler": "ཐིག་ཤིང༌།",
        "Sharpener": "པི་སི་གཞོག་ཆས།",
        "Scissors": "གྱིམ་ཙི།",
        "Table": "འབྲི་ཁྲི།",
        "White board": "བྱང་ཤིང་དཀརཔོ།",
        "Colours": "ཚོན།",
        "Colour": "ཚོན།",
        "Black": "གནགཔོ།",
        "Blue": "ཧོནམོ།",
        "Brown": "རྒྱ་སྨུག།",
        "Green": "ལྕང་ཁ།",
        "Grey": "ཐལ་མདོག།",
        "Orange": "ལི་ཝང༌།",
        "Pink": "ཤ་ཁ།",
        "Purple": "དམར་སྨུག།",
        "Red": "དམརཔོ།",
        "White": "དཀརཔོ།",
        "Yellow": "སེརཔོ།",
        "Clothes": "གོ་ལ།",
        "buttoned shirt": "Buttoned shirt",
        "gho": "Gho",
        "half pants": "Half pants",
        "Hook bra": "ཨོ་ཤུབས།",
        "Jacket": "ཇེ་ཀེཊ།",
        "Jeans": "རས་མཐུག་གི་དོརམ།",
        "kera": "Kera",
        "kira": "Kira",
        "Pants": "དོརམ།",
        "Rachu": "Rachu",
        "Shirt": "ཁེན་ཇ།",
        "Shoes": "ལྷམ།",
        "Socks": "ཨོམ་སོ།",
        "Sport bra": "ཨོ་ཤུབས།",
        "Sweater": "ཨོམ་སོ་ཁེན་ཇ།",
        "tsho lham": "Tsho lham",
        "Underwear": "ཨོམ་སོ་ཁེན་ཇ།",
        "Vest": "གཱན་ཛི།",
        "Continent": "གླིང་ཆེན།",
        'america': 'America',
        'asia': 'Asia',
        'south america': "South America",
        "north america": "North America",
        'africa': 'Africa',
        "Country": "རྒྱལ་ཁབ།",
        "afghanistan": "Afghanistan",
        "australia": "Australia",
        "austria": "Austria",
        "bangladesh": "Bangladesh",
        "belgium": "Belgium",
        "Bhutan": "འབྲུག་ཡུལ།",
        "brazil": "Brazil",
        "cambodia": "Cambodia",
        "canada": "Canada",
        "china": "China",
        "egypt": "Egypt",
        "england": "England",
        "france": "France",
        "germany": "Germany",
        "hong kong": "Hong Kong",
        "india": "India",
        "indonesia": "Indonesia",
        "iran": "Iran",
        "italy": "Italy",
        "Jamaica": "Jamaica",
        "japan": "Japan",
        "malaysia": "Malaysia",
        "mexico": "Mexico",
        "myanmar": "Myanmar",
        "nepal": "Nepal",
        "netherlands": "Netherlands",
        "north korea": "North Korea",
        "pakistan": "Pakistan",
        "panama": "Panama",
        "philippines": "Philippines",
        "russia": "Russia",
        "singapore": "Singapore",
        "south korea": "South Korea",
        "spain": "Spain",
        "sri lanka variant 1": "Sri Lanka Variant 1",
        "sri lanka variant 2": "Sri Lanka Variant 2",
        "switzerland": "Switzerland",
        "taiwan": "Taiwan",
        "thailand": "Thailand",
        "turkey": "Turkey",
        "ukraine": "Ukraine",
        "united states of america": "United States of America",
        "vietnam": "Vietnam",
        "Days of week": "རེས་གཟའ།",
        "Friday": "གཟའ་སྤེན་པ།",
        "Monday": "གཟའ་མིག་དམར།",
        "Saturday": "གཟའ་ཉིམ།",
        "Sunday": "གཟའ་ཟླཝ།",
        "Thursday": "གཟའ་པ་སངས།",
        "Tuesday": "གཟའ་ལྷག་པ།",
        "Wednesday": "གཟའ་ཕུརཔ།",
        "Disaster": "རྐྱེན་ངན་ཚབས་ཆེན།",
        "Earthquake": "ས་ཡོམ།",
        "Fire": "མེ།",
        "Flood": "ཆུ་རུད།",
        "Landslide": "ས་རུད།",
        "Storm": "རླུང་འཚུབ་དང་རླུང་ཆར་ལྟ་བུ།",
        "Dzongkhags": "རྫོང་ཁག།",
        "Bumthang": "བུམ་ཐང་།",
        "Chhukha": "ཆུ་ཁ་རྫོང་ཁག།",
        "Dagana": "དར་དཀར་ནང་།",
        "dzongkhag": "Dzongkhag",
        "gasa": "Gasa",
        "Haa": "ཧཱ།",
        "Lhuentse": "ལྷུན་རྩེ།",
        "Monggar": "མོང་སྒར།",
        "Paro": "སྤ་རོ།",
        "Pemagatshel": "པདྨ་དགའ་ཚལ།",
        "Punakha": "སྤུ་ན་ཁ།",
        "Samdrup jongkhar": "བསམ་གྲུབ་ལྗོངས་མཁར།",
        "Samtse": "བསམ་རྩེ།",
        "Sarpang": "གསར་སྤང་།",
        "Thimphu": "ཐིམ་ཕུག།",
        "Trashigang": "བཀྲ་ཤིས་སྒང་།",
        "Trashiyangtse": "བཀྲ་ཤིས་གཡང་རྩེ།",
        "Trongsa": "ཀྲོང་གསར།",
        "Tsirang": "རྩི་རང་།",
        "Wangdue phodrang": "དབང་འདུས་ཕོ་བྲང་།",
        "Zhemgang": "གཞམས་སྒང་།",
        "Environment": "གནས་སྟངས།",
        "Forest": "ནགས་ཚལ།",
        "Grass": "རྩྭ།",
        "Moon": "ཟླཝ།",
        "Mountain": "གངས་རི།",
        "Rainbow": "འཇའ།",
        "River": "གཙང་ཆུ།",
        "Sea": "མཚོ།",
        "Soil": "ས།",
        "Star": "སྐརམ།",
        "Stick": "འཁརཝ།",
        "Stone": "རྡོ།",
        "Stream": "རོང་ཆུ།",
        "Sun": "ཉིམ།",
        "Tree": "ཤིང་།",
        "Family member": "བཟའ་ཚང༌།",
        "Food & drinks": "བཟའ་འཐུང༌།",
        "Fruits": "ཤིང་འབྲས།",
        "Game": "རྩེད་རིགས།",
        "Household items": "ཁྱིམ་ནང་གི་ཅ་ཆས།",
        "Job": "གཡོག།",
        "Ministry": "ལྷན་ཁག།",
        "Money": "ཏི་རུ།",
        "Nu fifty": "དངུལ་ཀྲམ་ ༥༠།",
        "Nu five": "དངུལ་ཀྲམ་ ༥།",
        "Nu five hundred": "དངུལ་ཀྲམ་ ༥༠༠།",
        "Nu one": "དངུལ་ཀྲམ་ ༡།",
        "Nu one hundred": "དངུལ་ཀྲམ་ ༡༠༠།",
        "Nu one thousand": "དངུལ་ཀྲམ་ ༡༠༠༠།",
        "Nu ten": "དངུལ་ཀྲམ་ ༡༠།",
        "Nu twenty": "དངུལ་ཀྲམ་ ༢༠།",
        "Months": "ཟླཝ།",
        "Parts of tree": "ཤིང་གི་ཡན་ལག།",
        "Parts of a tree": "ཤིང་གི་ཡན་ལག།",
        "Place": "ས་གནས།",
        "Seasons": "ནམ་དུས།",
        "Season": "ནམ་དུས།",
        "Subjects": "ཆོས་ཚན།",
        "Time": "དུས་ཚོད།",
        "12 30": "12:30 pm",
        "Transportation": "སྐྱེལ་འདྲེན།",
        "Vegetables": "ཚོད་བསྲེ།",
        "Husband": "རྨགཔ།",
        "Grandmother": "ཨང་རྒས།",
        "Grandfather": "ཨ་རྒས།",
        "Daughter": "མབུམོ།",
        "Cousin": "སྤུན་ཆ།",
        "Aunty": "ཨ་ནེ།",
        "Aunt": "ཨ་ནེ།",
        "Son": "བུ།",
        "Uncle": "ཨ་ཁུ།",
        "Wife": "ཨམ་སྲུ།",
        "Biscuit": "ཁབ་ཟས།",
        "Bread": "བཱམ་རོ་ཊི།",
        "Butter": "མར།",
        "Cake": "མངར་ཁུར།",
        "Cheese": "དར་ཚི།",
        "Chicken": "བྱ་ཤ།",
        "Coffee": "ཀཱ་ཕི།",
        "Curd": "ཞོ།",
        "Curry": "ཚོདམ།",
        "Egg": "སྒོོང་རྡོག།",
        "Fish": "ཉ།",
        "Food and drinks": "བཟའ་འཐུང༌།",
        "Ice cream": "ཁྱེགས་ཟས།",
        "Jam": "ཇེམ།",
        "Juice": "ཤིང་འབྲས་ཁུ་བ།",
        "Meat": "ཤ།",
        "Milk": "ཨོམ།",
        "Momo": "མོ་མོ།",
        "Noodles": "རྒྱ་ཐུག།",
        "Oil": "མར་ཁུ།",
        "Pickle": "སྦྱོར་རྫས།",
        "Pizza": "པི་ཛ།",
        "Pork": "ཕག་ཤ།",
        "Rice": "ཆུམ།",
        "Roti": "ཏད་ཟས།",
        "Salt": "ཚྭ།",
        "Soup": "ཁུ་བ།",
        "Sugar": "གུ་རམ།",
        "Suja": "སྲུ་ཇ།",
        "Tea": "ཇ།",
        "Tetra pack juice with straw": "མངར་ཆུ་གཅིའུ།",
        "Water": "ཆུ།",
        "Water filter": "ཆུ་བཙག།",
        "Wine": "ཝའིན།",
        "juma": "Juma",
        "popcorn": "Popcorn",
        "Zaw": "མཛརཝ།",
        "Apple": "ཨེ་པཱལ།",
        "Apricot": "མངར་རིས་ཁམ།",
        "Banana": "ངང་ལག།",
        "Cardamom": "ཨ་ལཱན་ཅི།",
        "Cheery": "ཅེ་རི།",
        "Coconut": "བེ་ཏ།",
        "Cucumber": "གོན།",
        "Grapes": "རྒུན་འབྲུམ།",
        "Jackfruit": "སྦྲམ་ཟས།",
        "Litchi": "ལི་ཅི།",
        "Mango": "ཨམ་ཅུ་ཀུ་ལི།",
        "Orange(fruit)": "ཚལ་ལུ།",
        "Papaya": "མོ་དུ་ཕ་ལ།",
        "Peach": "ཁམ།",
        "Peanut": "བ་དམ།",
        "Pear": "གླི།",
        "Persimmon": "ཨཱན་འབྲས།",
        "Pineapple": "རྒྱ་ནག་ཀོང་ཙེ།",
        "Plum": "ཅུ་གླི།",
        "Pomegranate": "སེ་འབྲུ།",
        "Strawberry": "སྤང་གི་ཚལ་ལུ།",
        "Sugarcane": "གུན་ཆ།",
        "Walnut": "སྟར་ཀོ།",
        "Watermelon": "ཁ་རི་མུ་ཟ།",
        "Badminton": "dro tsé།",
        "Basketball": "དྲྭ་རིལ་རྩེདམོ།",
        "Carrom": "ཀེ་རོམ།",
        "Football": "རྐང་རྩེད།",
        "Lawn tennis": "ཐང་རིལ།",
        "Skipping rope": "མཆོང་ཐག།",
        "Snooker": "སི་ནུ་ཀར།",
        "Volleyball": "ལག་རིལ་རྩེདམོ།",
        "Bucket": "རྡོབ།",
        "Cup": "ཕོརཔ།",
        "Curry cooker": "ཀཱ་རི་ཀུ་ཀར།",
        "Fork": "རྐང་ཀྲ།",
        "Gas stove": "ཐབ།",
        "Glass": "ཤེལ་ཕོར།",
        "Knife": "གྱི་ཅུང༌།",
        "Mug": "མོག།",
        "Plate": "ཐ་ལི།",
        "Pot": "རྫམ།",
        "Rice cooker": "རའིསི་ཀུ་ཀར།",
        "Spoon": "ཐུརམ།",
        "Television": "རྒྱང་མཐོང༌།",
        "Washing machine": "འཁྱུ་བཤལ་འཕྲུལ་ཆས།",
        "Water boiler": "ཝ་ཀྲར་བོའི་ལར།",
        "Carpenter": "ཤིང་བཟོ་བོ།",
        "Doctor": "དྲུང་འཚོ།",
        "Electrician": "གློག་མེ་བཙུགས་མི།",
        "Engineer": "བཟོ་དཔོན།",
        "Guard": "སྲུང་རྒྱབ།",
        "Judge": "དྲང་དཔོན།",
        "Nurse": "སྨན་གཡོགམོ།",
        "Pilot": "གནམ་གྲུའི་དེད་དཔོན།",
        "Police": "ཁྲིམས་སྲུང་འགག་པ།",
        "Shopkeeper": "ཚོང་པ།",
        "Teacher": "སློབ་དཔོན།",
        "ministry of agriculture and forests":
            "Ministry of Agriculture and Forests",
        "ministry of economic affairs": "Ministry of Economic Affairs",
        "ministry of education": "Ministry of Education",
        "ministry of finance": "Ministry of Finance",
        "ministry of foreign affairs": "Ministry of Foreign Affairs",
        "ministry of health": "Ministry of Health",
        "ministry of home and cultural affairs":
            "Ministry of Home and Cultural Affairs",
        "ministry of information and communications":
            "Ministry of Information and Communications",
        "ministry of labour and human resources":
            "Ministry of Labour and Human Resources",
        "ministry of works and human settlement":
            "Ministry of Works and Human Settlement",
        "Nu 1": "དངུལ་ཀྲམ་ ༡།",
        "Nu 5": "དངུལ་ཀྲམ་ ༥།",
        "Nu 10": "དངུལ་ཀྲམ་ ༡༠།",
        "Nu 20": "དངུལ་ཀྲམ་ ༢༠།",
        "Nu 50": "དངུལ་ཀྲམ་ ༥༠།",
        "Nu 100": "དངུལ་ཀྲམ་ ༡༠༠།",
        "Nu 500": "དངུལ་ཀྲམ་ ༥༠༠།",
        "Nu 1000": "དངུལ་ཀྲམ་ ༡༠༠༠།",
        "April": "སྤྱི་ཟླ་ ༤ པ།",
        "August": "སྤྱི་ཟླ་ ༨ པ།",
        "December": "སྤྱི་ཟླ་ ༡༢ པ།",
        "February": "སྤྱི་ཟླ་ ༢ པ།",
        "January": "སྤྱི་ཟླ་ ༡ པ།",
        "July": "སྤྱི་ཟླ་ ༧ པ།",
        "June": "སྤྱི་ཟླ་ ༦ པ།",
        "March": "སྤྱི་ཟླ་ ༣ པ།",
        "May": "སྤྱི་ཟླ་ ༥ པ།",
        "November": "སྤྱི་ཟླ་ ༡༡ པ།",
        "October": "སྤྱི་ཟླ་ ༡༠ པ།",
        "September": "སྤྱི་ཟླ་ ༩ པ།",
        "Branch": "ཞལ་ལག།",
        "Bud": "སྦུབ་ཅུང་།",
        "Flower": "མེ་ཏོག།",
        "Fruit": "རྡོག་མ།",
        "Leaf": "འདབ་མ།",
        "Root": "ར་ཏོག།",
        "Trunk": "སྡོང་པོ།",
        "Children park": "ཨ་ལོའི་སྐྱེད་ཚལ། ཨ་ལོའི་གླིང་ག།",
        "Chorten stupa": "མཆོད་རྟེན།",
        "City": "ཁྲོམ་སྡེ།",
        "Dzong": "རྫོང་།",
        "Hospital": "སྨན་ཁང་།",
        "Hostel": "ཉལ་ཁྱིམ།",
        "Hotel": "ཟ་ཁང་།",
        "House": "ཁྱིམ།",
        "Market": "ཁྲོམ།",
        "Office": "ཡིག་ཚང་།",
        "Salon": "བཟོ་བཅོས་ཁང་།",
        "School": "སློབ་གྲྭ།",
        "Shop": "ཚོང་ཁང་།",
        "Temple": "ལྷ་ཁང་།",
        "Town": "ཁྲོམ།",
        "Autumn": "སེར་ཁ།",
        "Spring": "སོ་ཁ།",
        "Summer": "གནམ་བྱཱར།",
        "Winter": "གནམ་དགུན།",
        "Agriculture": "སོ་ནམ།",
        "Arts": "སྒྱུ་རྩལ།",
        "Biology": "སྐྱེ་ལྡན་རིག་པ།",
        "Carpentry": "ཤིང་བཟོ།",
        "Chemistry": "རྫས་ཁམས་རིག་པ།",
        "English": "དབྱིན་སྐད།",
        "Geography": "ས་ཆ་རིག་པ།",
        "History": "བྱུང་རབས།",
        "Mathematics": "ཨང་རྩིས།",
        "Painting": "ཤིང་ཚོན།",
        "Physical education": "ལུས་སྦྱོང་ཤེས་ཡོན།",
        "Science": "ཚན་རིག།",
        "Sign language": "ལག་བརྡ་ཁ་སྐད།",
        "Bhutanese Sign Language": "འབྲུག་པའི་ལག་བརྡ་སྐད་ཡིག།",
        "Explore our Signs": "ལག་བརྡ་ཁ་སྐད།",
        "Signs": "ལག་བརྡ་ཁ་སྐད།",
        "Category": "དབྱེ༌ཁག།",
        "Social studies": "མི་སྡེ་ཤེས་ཡོན།",
        "Subject": "ཆོས་ཚན།",
        "Tailoring": "ཚེམ་བཟོ།",
        "Vocational": "ལག་རྩལ།",
        "Weaving": "ཐགས་བཟོ།",
        "Wood carving": "པ་ཏྲ།",
        "3 o clock": "ཆུ་ཚོད་༣།",
        "12:30": "༡༢:༣༠",
        "12:30 pm": "༡༢:༣༠",
        "Afternoon": "ཉིན་མ།",
        "Evening": "ཕྱི་རུ།",
        "Future": "མ་འོངས་པ།",
        "Hour": "ཆུ་ཚོད།",
        "Last year": "ན་ཧིང་།",
        "Minute": "སྐར་མ།",
        "Morning": "དྲོ་པ།",
        "Next year": "སང་ཕོད།",
        "Next": "རྟིང་མ།",
        "Previous": "གོང་ལུ།",
        "Night": "ནུབ་མོ།",
        "Second": "སྐར་ཆ།",
        "This year": "དུས་ཅུ།",
        "Today": "ད་རེས།",
        "Tomorrow": "ནངས་པ།",
        "Week": "བདུན་ཕྲག།",
        "Year": "སྤྱི་ལོ།",
        "Yesterday": "ཁ་ཙ།",
        "Archery": "མདའ་རྩེད།",
        "Dego": "རྡོས་སྒོར།",
        "Khuru": "ཁུ་རུ།",
        "Traditional games": "སྔར་སྲོལ་གྱི་རྩེདམོ།",
        "Aeroplane": "གནམ་གྲུ།",
        "Ambulance": "ནད་འཁོར།",
        "Bicycle": "རྐང་འཁོར།",
        "Boat": "གྲུ།",
        "Bus": "བཱསི།",
        "Car": "ཀཱར།",
        "Helicopter": "ཐད་འཕུར་གནམ་གྲུ།",
        "Hilux": "ཧའི་ལཀསི།",
        "Motorbike": "མོ་ཊོར་བའེཀ།",
        "Scooter": "སི་ཀུ་ཊར།",
        "Ship": "གྲུ་ཆེན།",
        "Taxi": "གླ་འཁོར།",
        "Tipper": "ཀྲི་པཱར།",
        "Train": "རེལ་ལི།",
        "Truck": "ཊག།",
        "Van": "ཝེན།",
        "Beans": "སྲནམ་ཅུམ།",
        "Bitter gourd": "ཁག་ཏེགམ།",
        "Brinjal": "དོ་ལོམ།",
        "Broccoli": "མེ་ཏོག་ཧོན་ཚོད།",
        "Cabbage": "འདབ་མ་ཀོ་པི།",
        "Caigua": "ཨོ་ལ་མཆོ་ཏོ།",
        'caigue': "Ciague",
        "Carrot": "ལ་ཕུག་དམརཔོ།",
        "Cauliflower": "མེ་ཏོག་ཀོ་པི།",
        "Chilli": "ཨེ་མ།",
        "Coriander": "འོད་སི།",
        "Garlic": "སྐྱ་སྒོགཔ།",
        "Ginger": "ས་སྒ།",
        "Ladyfinger": "གླང་ཅུང་རཱཝ།",
        "Mushroom": "ཤ་མུ།",
        "Onion": "སྒོགཔ།",
        "Peas": "བོད་སྲནམ།",
        "Potato": "ཀེ་བ།",
        "Pumpkin": "ཀ་ཀུར།",
        "Radish": "ལ་ཕུག།",
        "Spinach": "ཧོན་ཚོད།",
        "Squash": "སྦལ་ཁ།",
        "Tomato": "བླམ་བན་ད།",
        "Turnip": "གཡུང་རྡོག།",
        'settings': 'Settings',
        'ai': 'AI',
        'Question':'དྲི་བ།',
        'Your score':'ཁྱོད་ཀྱི༌སྐུགས།',
        'Exit':'འཐོན་སྒོ',
        'Try again':'ལོག་སྟེ།',
        'Correct! Continue':'བདེན། དྲི་བ་ཤུལ་མམ་འཕྲོ་མཐུད།',
        'Nice try! Continue':'འཛོལ༌བ། དྲི་བ་ཤུལ་མམ་འཕྲོ་མཐུད།',
        'Check':'བདེན་དཔྱད་འབད།',
        'Wangsel Institute': 'དབང་གསལ་སྤེལ་ཁང་།',
        'Copyright':'པར་དབང་',
        'Play audio': 'སྒྲ།',
        'home':'གདོང་ཤོག།',
        'signsCategory': 'ལག་བརྡ་ཁ་སྐད།',
        'Others':'གཞན།',
        'feedback':'བསམ་ལན།'
        // 'feedback':'Feedback'
        // 'revenge':'ངན་ལན།',
        // 'story 1':'བདེན་དཔྱད་འབད།',
        // 'phrase 1':'བདེན་དཔྱད་འབད།',

  }
};

export default translations;
